import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { authService } from '../services/api';

const AcceptInvite = ({ onAcceptSuccess }) => {
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  
  // Get invite token from URL query params
  const location = useLocation();
  const inviteToken = new URLSearchParams(location.search).get('token');
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    
    // Validate inputs
    if (password !== confirmPassword) {
      setError('Passwords do not match');
      return;
    }
    
    if (!inviteToken) {
      setError('Invalid invitation link');
      return;
    }
    
    setLoading(true);
    
    try {
      // According to CSV: PUT /user/register_from_invitation with first_name, last_name, email, password, confirm_password
      const userData = {
        first_name: firstName,
        last_name: lastName,
        email: email,
        password: password,
        confirm_password: confirmPassword,
        invite_token: inviteToken // Include the token for validation
      };
      
      console.log('Accepting invite with data:', userData);
      
      const response = await authService.acceptInvite(userData);
      
      // Handle successful registration
      if (response && response.data) {
        // Store auth token if provided
        if (response.data.auth_token) {
          localStorage.setItem('token', response.data.auth_token);
        }
        
        // Pass user data to success handler
        onAcceptSuccess(response.data.user || response.data);
      }
    } catch (err) {
      console.error('Failed to accept invitation:', err);
      setError(err.response?.data?.message || 'Failed to create account. Please try again.');
    } finally {
      setLoading(false);
    }
  };
  
  if (!inviteToken) {
    return (
      <div className="auth-container">
        <div className="auth-form">
          <h2>Invalid Invitation</h2>
          <p>The invitation link is invalid or has expired.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-container">
      <div className="auth-form">
        <h2>Create Your Account</h2>
        <p>Complete your registration to join Task Timeline</p>
        {error && <div className="error-message">{error}</div>}
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="firstName">First Name</label>
            <input
              type="text"
              id="firstName"
              value={firstName}
              onChange={(e) => setFirstName(e.target.value)}
              required
              minLength={3}
              maxLength={50}
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="lastName">Last Name</label>
            <input
              type="text"
              id="lastName"
              value={lastName}
              onChange={(e) => setLastName(e.target.value)}
              required
              minLength={3}
              maxLength={50}
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              minLength={6}
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="confirmPassword">Confirm Password</label>
            <input
              type="password"
              id="confirmPassword"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
            />
          </div>
          
          <button 
            type="submit" 
            className="submit-btn" 
            disabled={loading}
          >
            {loading ? 'Creating Account...' : 'Create Account'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AcceptInvite; 